import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const LAYOUT_ACTIONS = new InjectionToken<LayoutActions>('');

export interface LayoutActions {
  toggleSideBar(open?: boolean): void;

  openSideBar(): void;

  closeSideBar(): void;

  showLoginDialog(): void;

  closeLoginDialog(): void;

  showAppMenu(): void;
  closeAppMenu(): void;

  toggleLoadingBar(loading?: boolean): void;
  toggleFullscreen(fullscreen?: boolean): void;
}

export const LAYOUT_QUERIES = new InjectionToken<LayoutQueries>('');

export interface LayoutQueries {
  isSideBarOpen$: Observable<boolean>;

  showLoginDialog$: Observable<boolean>;

  getShowLoginDialog(): boolean;

  showAvailabilityError$: Observable<boolean>;

  getShowAppMenu(): boolean;

  showAppMenu$: Observable<boolean>;

  isLoading$: Observable<boolean>;

  isFullscreen$: Observable<boolean>;
}
